<template>
    <span class="event-item"
        :key="note.id">
        <span class="event-item-header">
            <el-checkbox v-model="isNoteSelected" class="questionnaire-checkbox">{{ note.title }}</el-checkbox>
            <span class="edited-by" v-if="notesVersion.created_by !== 'Doctorplan' && isNoteSelected ">
                <img style="padding-right: 5px;" src="./img/edit.svg" />
                Edited on {{ formatDateTime(notesVersion.created) }} by 
                {{ notesVersion.created_by }}
            </span>
            <button v-show="isNoteSelected" class="questionnaire-save-button" @click="callUpdateChartNote" :disabled="!hasNoteBeenEdited || updating">
                <i v-if="updating" class="el-icon-loading"></i>
                <img v-else src="./img/save.svg" />
                Save
            </button>
        </span>
        <div class="notes" v-show="isNoteSelected">
            <TextEdit 
                :key="note.id"
                class="text-edit expanded"
                v-model="copyNotes"
            ></TextEdit>
        </div>
    </span>
</template>

<script>
import { mapActions } from 'vuex'
import formatDateTime from '@/module/util/format-date-time'

import TextEdit from '@/module/component/TextEdit'
export default {
    name: 'notes-dialog-chart',

    data() {
        return {
            isNoteSelected: this.value.selected,
            initialNote: this.notesVersion.text.replaceAll('\n', '<br>'),
            copyNotes: this.notesVersion.text.replaceAll('\n', '<br>'),
            updating: false,
        }
    },

    watch: {
        isNoteSelected: {
            handler(newValue) {
                this.$emit('input', {
                    selected: newValue,
                    edited: this.hasNoteBeenEdited
                })
            }
        },
        hasNoteBeenEdited: {
            handler(newValue) {
                this.$emit('input', {
                    selected: this.isNoteSelected,
                    edited: newValue
                })
            }
        }
    },

    props: {
        value: {
            type: Object,
            required: true
        },
        patient: {
            type: Object,
            required: true
        },
        note: {
            type: Object,
            required: true
        },
        notesVersion: {
            type: Object,
            required: true
        }
    },

    methods: {
        ...mapActions('provider', ['updateChartNote']),
        formatDateTime,
        /**
         * Update the chart note to a newer version
         */
        callUpdateChartNote() {
            this.updating = true
            this.updateChartNote({
                id: this.patient.id,
                provider: this.notesVersion.provider_id,
                questionnaire_id: this.note.id,
                update: this.copyNotes
            }).then((response) => {
                this.$message({
                    message: 'Changes saved successfully',
                    type: 'success'
                })
            }).catch((error) => {
                if(!error.success)
                    this.$message.error("Problem saving changes")
            }).finally((_) => this.updating = false)
        }
    },

    computed: {
        /**
         * Check if the notes have been edited
         */
        hasNoteBeenEdited() {
            const initialNote = this.notesVersion.text.replaceAll('\n', '<br>')
            return this.copyNotes !== initialNote
        },
    },

    components: {
        TextEdit
    }

}
</script>

<style lang="scss" scoped>
@import './style.scss';
.event-item {
    .event-item-header {
        padding-bottom: 3px;
        display: flex;
    }
    .edited-by {
        flex-grow: 1;
        text-align: right;
        font-size: 12px;
        color: #666666;
        padding-right: 15px;
    }
    .notes {
        background-color: #ffffff;
        border-radius: 10px;
        padding-top: 12px;
        padding-bottom: 12px;
        line-height: 24px;
    }
}

</style>